import React from 'react';
import { Page } from './page';

import { EntitiesArray } from '../components/island';
import { upgrades } from '../actions/upgradesArray';

import Player from '../functions/player';

import { GameInfo } from '../components/gameInfo';
import { Restore } from '../components/restore';

export class Scenario extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      partOfGame: 6,
      timerOver: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    const newPart = Player.getData('partOfGame');

    this.setState({
      partOfGame: newPart,
    });
  }

  componentWillUnmount() {
    let currentRound = Player.getData('round');
    let newRound = currentRound + 1;
    Player.storeData('round', newRound);
  }

  handleClick(){
    this.setState({
      timerOver: true,
    })
  }

  nextRound = () => {
    this.refs.GameInfo.nextRound();
    return;
  }

  getScenario(){
    let currentRound = Player.getData('round');

    if (currentRound === 1) {
      // Lower all funds with 10%;
      for (var i = 0; i < EntitiesArray.length; i++) {
        let data = EntitiesArray[i];

        if (data['type'] !== 'Government') {
          let newFunds = data['funds'] * 0.9;
          data['funds'] = newFunds;
        }
      }

      return <p>Alarm! Het gaat niet snel genoeg.<br/> Ondanks alle inspanningen is de zeespiegel verder gestegen. De overheid moet de kust versterken en daar is geld voor nodig.<br /> De inkomstenbelasting wordt verhoogd met 10%.<br /> Check hoeveel geld je nog hebt!</p>;
    } else if (currentRound === 2) {
      // Destroy all network connections
      upgrades[0]['purchased'].splice(0, upgrades[0]['purchased'].length);

      return <p>De extreme stormen die rond de jaarwisseling hebben huisgehouden op het eiland hebben het complete elektriciteitsnetwerk platgelegd.<br/>  Iedereen moet zijn netwerkaansluiting herstellen.<br/>  Zorg voor een werkende aansluiting om elektriciteit te kopen of te leveren!</p>;
    } else {
      throw new Error("Het is niet gelukt het spel te hervatten. Start het spel opnieuw en vul je spelcode in op de homepagina om te hervatten.");
    }
  }

  onVideoClick = () => {
    const video = this.refs.video;
    video.paused?video.play():video.pause();
  }

  getVideo = () => {
    let currentRound = Player.getData('round');
    if (currentRound === 1) {
      return '/game/untracked/scenario-round-2.mp4'; // require("../assets/videos/video.mp4");
    } else {
      return '/game/untracked/scenario-round-3.mp4'; //require("../assets/videos/video.mp4");
    }
  }

  render() {
    let content = <video onClick={this.onVideoClick} ref="video" autoPlay="true" controls>
        <source src={this.getVideo()} type="video/mp4"/>
        Your browser does not support the video tag.
      </video>;

    return(
      <Page pageTitle="Ronde-overgang" imageSet="2">
      <Restore />
        <div className="col">
          <h2>Breaking news!</h2>
          { this.getScenario() }
        </div>
        <div className="col">
          <div className="videoSmall">
            { content }
          </div>
          <div className="scenario-info gameInfo-Timeonly">
            <GameInfo ref="GameInfo" part={this.state.partOfGame} getGameScreen={() => {return this.props.location.pathname}}  />
            <button className="btn_scenario bigButton" onClick={this.nextRound}>{"Start ronde " + (Player.getData("round") === undefined ? 2 : Player.getData("round") + 1)}</button>
          </div>
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/scenario.js